import {
  Component,
  computed,
  EventEmitter,
  input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { faGears, faFloppyDisk, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { OConfigService } from '@olameter/o-config-service';
import { EMPTY, Subscription, tap } from 'rxjs';
import { WorkorderGRPCService } from '../../../ProxyServices/workorder.grpc.service';
import { WOStatusOptions, WOStatusWeb } from '../../../constants/woStatusOptions';
import { ViewResponseModel, WoAdminModel, WorkOrderBase, WorkOrderModel } from 'src/app/CommonFiles/BusinessModels';
import { OAuthService } from '@olameter/o-authentication';

@Component({
  standalone: false,
  selector: 'app-mass-status-update',
  templateUrl: './mass-status-update.component.html',
  styleUrls: ['./mass-status-update.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MassStatusUpdateComponent {
    faGears = faGears;
    faTimes = faTimes;
    faFloppyDisk = faFloppyDisk;
    subscriptions: Subscription[] = [];
    woStatusOptions = WOStatusOptions;

    @Output() completedEvent: EventEmitter<any> = new EventEmitter<any>();

    readOnlyMode = input<boolean>(false);
    active = input<ViewResponseModel>(null);
    selectedWorkOrders = input<WorkOrderBase[]>([]);
    public showStatusPopup: boolean = false;
    public showWarning: boolean = false;
    public isSubmit: boolean = false;
    public woStatus: number;
    public woStatusName: string = '';
    public skipCode: string = '';
    public comment: string = '';
    public taskToCreate: string = '';
    public woAdmin: WoAdminModel;
    public confirmText = '';
    public collection1 = [];
    public collection2 = [];
    public taskList = [];

    buttonsEnableState = computed<boolean>(() => {
      const selectedWOInfo: {status: string, sentToReport: boolean}[] = this.selectedWorkOrders().map(x => ({status: x.StatusWeb, sentToReport: x.MexFlag}));
      return MassStatusUpdateComponent.enableButton(selectedWOInfo, this.authService.userName());
    });

    private allowedWebStatus: WOStatusWeb[] = [];    
    private _taskWoAdmin;
    
    constructor(public _clientWO: WorkorderGRPCService, private config: OConfigService, private authService: OAuthService) {
        this.allowedWebStatus.push(WOStatusWeb.AwaitingAppointment);
        this.allowedWebStatus.push(WOStatusWeb.CSRHold);
        this.allowedWebStatus.push(WOStatusWeb.Completed);
        this.allowedWebStatus.push(WOStatusWeb.ReadyForDispatch);
        this.allowedWebStatus.push(WOStatusWeb.ReturnToUtility);
        this.allowedWebStatus.push(WOStatusWeb.UtilityHold);
    }

    showMassStatusUpdate() {
        this.getAdminTaskConfig().subscribe(() => {
            this.showStatusPopup = true;
        });
    }

    private getAdminTaskConfig() {
        if (this.selectedWorkOrders().length === 0) return EMPTY;

        const wo = this.selectedWorkOrders()[0];

        this._clientWO
            .getTaskList(wo.ContractId, wo.ServiceType)
            .subscribe((items) => {
                this.taskList = items;
        });

        return this._clientWO
            .getWoAdminTaskConfig(wo.ContractId, wo.ServiceType)
            .pipe(
            tap(task => {
                this._taskWoAdmin = task;
                this.woAdmin = null;
                
                if (task) {
                    this.woAdmin = new WoAdminModel();
                    this.woAdmin.comment_title = task.pages[0].controlsList[0].text3;
                    this.woAdmin.taskName = task.name;
                    this.woAdmin.skipCodeSource = task.pages[0].controlsList[0].Collection1;
                    this.woAdmin.workOrderStatus = task.conditions[0]?.wo_status?.toString();
                    this.woAdmin.workOrderStatusSource = task.pages[0].controlsList[0].Collection2;
                    this.woAdmin.taskToCreate = task.conditions[0]?.task_to_create_gui_id;
                }

                if (this.woAdmin != null) {
                    this._clientWO
                        .getCollectionItems(this.woAdmin.skipCodeSource)
                        .subscribe((items) => {
                            this.collection1 = items;
                        });
                
                    this._clientWO
                        .getCollectionItems(this.woAdmin.workOrderStatusSource)
                        .subscribe((items) => {
                            this.collection2 = items.filter(x => this.allowedWebStatus.findIndex(s => s.toLowerCase() == x.item_name.toLowerCase().replace(/\s+/g, '')) != -1);
                        });
                }
            })
        );
    }

    static enableButton(selectedWOInfo: {status: string, sentToReport: boolean}[], user: string) {
      var enableButton = false;
      if (selectedWOInfo.length) {
        var admins = ["lbathalon@olameter.com","bnoronha@olameter.com","brian.noronha@olameter.com","rahul.chittanuri@olameter.com","colby.burston@olameter.com","adminpreprod@olameter.com"];

        if(admins.includes(user.toLowerCase())){
            enableButton = true;
        }else{
            enableButton = selectedWOInfo.every(
                    (x) => !x.sentToReport && x.status != "Completed" && x.status != "ReturnToUtility" 
                    );
        }        
      }
      return enableButton;
    }

    public listValueChange1(e) {
        this.skipCode = e ?? '';
    }

    public listValueChange2(e) {
        this.woStatus = e ?? null;

        var item = this.collection2.find(
                (x) => x.id.toString() == this.woStatus
            );
            
        this.woStatusName = item?.item_name;
    }

    public tasklistValueChange(e) {
        this.taskToCreate = e ?? '';
    }

    public closeForm() {
        this.resetValue();
        this.showStatusPopup = false;
        this.showWarning = false;
        this.isSubmit = false;
    }

    public confirm(){
        this.confirmText = '';
        this.showWarning = true;
    }

    public confirmCancel(){
        this.showWarning = false;
    }

    public onConfirmTextChange(value: string): void {
        this.confirmText = value.toUpperCase();
    }

    public save() {
        this.isSubmit = true;

        this.woAdmin.workOrderStatus = this.woStatus.toString();
        this.woAdmin.skipCode = this.skipCode;
        this.woAdmin.comment = this.comment;
        this.woAdmin.taskToCreate = this.taskToCreate;

        const woList = structuredClone(this.selectedWorkOrders()) as WorkOrderModel[];

        woList.forEach(wo => {
            wo.JsonData[this._taskWoAdmin.pages[0].controlsList[0].destination1.split('.')[0]]
                [this._taskWoAdmin.pages[0].controlsList[0].destination1.split('.')[1]] = this.woAdmin.skipCode;
            wo.JsonData[this._taskWoAdmin.pages[0].controlsList[0].destination3.split('.')[0]]
                [this._taskWoAdmin.pages[0].controlsList[0].destination3.split('.')[1]] = this.woAdmin.comment;
        });

        const data = {
            workOrders: woList,
            woAdmin: this.woAdmin,
        };

        this._clientWO.workOrderAdminMassUpdate(data).subscribe((result) => { 
            // Validate that result is a non-empty array of strings
            if (!result || !Array.isArray(result) || result.length === 0) {
                console.warn('Mass update returned invalid or empty result:', result);
                this.closeForm();
                return;
            }  

            const wos = woList.filter(x => result.includes(x.name));
            const item = this.collection2.find(
                    (x) => x.id.toString() == this.woStatus
                );
            const woStatus = this.woStatusOptions.find(x => x.text.toLowerCase().replace(/\s+/g, '') === item.item_name.toLowerCase().replace(/\s+/g, ''));
            //update status
            wos.forEach(wo => {
                wo.StatusWeb = woStatus ? woStatus.value : item.item_name;
                wo.AssignedTo = this.woStatus === 4 ? '' : wo.AssignedTo
            });
            this.complete(wos)
        });               
    }

    public complete(e) {
        this.resetValue();
        this.showStatusPopup = false;
        this.showWarning = false;
        this.isSubmit = false;
        this.completedEvent.emit(e);
    }

    private resetValue(){
        this._taskWoAdmin = null;
        this.woStatus = null;
        this.woStatusName = '';
        this.skipCode = '';
        this.comment = '';
        this.taskToCreate = '';
        this.woAdmin = null;
        this.confirmText = '';
    }
}
